import { Grid } from '@mui/material';
import SignUpForm from '@/components/singUp/signUp';

const SignUpPage = () => {
  return (
    <Grid container justifyContent="center" alignItems={'flex-start'} spacing={4}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SignUpForm />
      </Grid>
    </Grid>
  );
};

export default SignUpPage;
